import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

const AcknowledgementList = () => {
  return (
    <ul
      className="sui-list-disc sui-pb-2 sui-pl-4 sui-flex sui-flex-col sui-gap-2"
      data-testid="acknowledgement-list"
    >
      <li>
        <Typography variant="body-base" height="tight">
          A person 18 years or older must be present at the time of pickup.
        </Typography>
      </li>
      <li>
        <Typography variant="body-base" height="tight">
          The product must be in a condition and location that allows the
          carrier to successfully complete the pickup.
        </Typography>
      </li>
    </ul>
  );
};

export default AcknowledgementList;
